"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RpcClient = exports.RpcError = void 0;
const axios_1 = __importDefault(require("axios"));
class RpcError extends Error {
    constructor(err) {
        let message = err.message;
        if (err.data) {
            message += `: ${JSON.stringify(err.data, null, 4)}`;
        }
        super(message);
        this.code = err.code;
        this.data = err.data;
    }
}
exports.RpcError = RpcError;
class RpcClient {
    constructor(endpoint) {
        const httpCliOptions = {
            headers: { "Content-Type": "application/json" },
        };
        this._httpCli = axios_1.default.create(httpCliOptions);
        this._endpoint = endpoint;
        this._idCounter = 0;
    }
    async call(method, params) {
        const single = typeof method === "string";
        const requests = (single ? [{ method, params }] : method).map(({ method, params }) => ({
            jsonrpc: "2.0",
            id: this._idCounter++,
            method,
            params,
        }));
        if (requests.length == 0) {
            return [];
        }
        const { data } = await this._httpCli.post(this._endpoint, single ? requests[0] : requests);
        if (single) {
            const { error, result } = data;
            if (error) {
                return Promise.reject(new RpcError(error));
            }
            return result;
        }
        const results = [];
        for (const { error, result } of data) {
            if (error) {
                return Promise.reject(new RpcError(error));
            }
            results.push(result);
        }
        return results;
    }
}
exports.RpcClient = RpcClient;
//# sourceMappingURL=rpc-client.js.map